import { IModularEnrolmentSummary } from '../../../redux/slices/ModularEnrolmentSlice/types';

export const getModularEnrolmentSummarySegmentProperties = (
    summary: Partial<IModularEnrolmentSummary>,
    balance?: number
): Record< string, unknown> => {
    return {
        Base_Policy_plan_type: summary.modular?.name,
        Base_Policy_plan_Sum_insured: summary.modular?.sumInsured,
        Base_Policy_plan_premium: summary.modular?.price,
        Ala_Carte_plans: summary.alacarte?.map((benefit) => ({
            type: benefit?.name,
            premium: benefit?.price,
            cover: benefit?.sumInsured
        })),
        priceSummary: { ...summary.priceSummary, wallet_Balance: balance }
    };
};
